import { Box, CircleTag, Text } from '@factorialco/deprecated-design-system'

import OauthService from 'modules/payroll_integrations_a3innuva/lib/OauthService'
import { Status } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

interface Props {
  status: Status
}

const Tag = ({ status }: Props) => {
  return (
    <Box width="full" flexDirection="row" gap="s16">
      <Box flexDirection="row" alignItems="center">
        <Box
          flexDirection="row"
          alignItems="center"
          style={{ marginTop: '15px', marginRight: '15px', marginBottom: '15px' }}
        >
          <CircleTag showCircle type={OauthService.statusToTagColor()[status]}>
            {OauthService.statusLabel()[status]}
          </CircleTag>
        </Box>

        <Text.Normal size="200">{OauthService.statusDescription()[status]}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Tag
